module.exports = __webpack_public_path__ + "static/img/4.ab5cc92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/global/4.png
// module id = iXOj
// module chunks = 1